// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 912) return "awsutilityVendor.77e2495b6b24ff6ea636.js";
	if (chunkId === 123) return "muiVendor.c7ad1aa417b468c88cf1.js";
	// return url for filenames based on template
	return "chunk." + chunkId + ".js";
};